<template>
  <v-app style="background-color: transparent; height: 100vh; overflow: auto">
    <v-main>
      <v-card id="main-card" color="transparent" tile class="d-flex align-center" style="height: 100%; width: 100%">
        <router-view />
      </v-card>
    </v-main>
    <sg-root-modal />
    <sg-root-loader />
  </v-app>
</template>

<script>
  import SgRootModal from '@/components/SgRootModal'
  import SgRootLoader from '@/components/SgRootLoader'

  export default {
    components: {
      SgRootModal,
      SgRootLoader
    },
    computed: {
      theme() {
        return this.$store.state.options && this.$store.state.options.theme
      },
      demo() {
        return this.$store.state.options && this.$store.state.options.demo
      },
      test() {
        return this.$store.state.options && (this.$store.state.options.test === true || this.$store.state.options.test === "true")
      },



      widgetType() {
        return this.$store.state.options && this.$store.state.options.widgetType
      }
    },
    watch: {
      theme() {
        this.$vuetify.theme.dark = this.theme == 'dark'
      },
      test() {
        if (this.test) {
          console.info("switch to test")
        } 
        else {
          console.info("switch to normal")
        }
        this.$api.url = (this.test ? process.env.VUE_APP_TEST_URL : process.env.VUE_APP_URL)+'v'+process.env.VUE_WIDGET_VERSION+'/api'
      },
      demo() {
        this.$api.useMocks = this.demo
      },
      widgetType(val, oldVal) {
        if (oldVal) {
          this.reloadWidget()
        }
      }
    },

    methods: {

      startLoading() {
        this.$eventBus.$emit('loader:show', {
          loaderText: "Загрузка..."
        })
      },

      stopLoading() {
        this.$eventBus.$emit('loader:hide')
      },

      reloadWidget() {
        
        this.startLoading()
        this.$store.dispatch('RELOAD_WIDGET')
          .then(res => {

    
            if (this.$route.name != 'search') {
              this.$router.push({
                name: 'search'
              })
            }

          })
          .catch(err => {
            console.error("widget reload failed: ", err)
            if (this.$route.name != 'error') {
              this.$router.push({
                name: 'error',
                params: {
                  error: 'Сервис временно недоступен.'
                }
              })
            }

          })
          .finally(() => {
            this.stopLoading()
          })
      },


      fetchWidget() {

        this.startLoading()

        this.defineApi(this.$route.query)

        this.$store.dispatch('INIT_WIDGET', {
            options: this.$route.query,
            uuid: this.$route.query.uuid
          })
          .then(res => {

          /*   this.$watch("widgetType", this.reloadWidget) */

            this.postMessage('callback:invoke', {
              callbackId: this.$store.state.uuid,
              callbackArgs: {
                error: false
              }
            })

            if (this.$route.name != 'search') {
              this.$router.push({
                name: 'search'
              })
            }

          })
          .catch(err => {
            console.error("widget loading failed: ", err)
            this.postMessage('widget:ready', {
              callbackId: this.$store.state.uuid,
              callbackArgs: {
                error: true,
                errorMessage: err
              }
            })
            if (this.$route.name != 'error') {
              this.$router.push({
                name: 'error',
                params: {
                  error: 'Сервис временно недоступен.'
                }
              })
            }
          })
          .finally(() => {
       /*      this.ready = true
            this.loaderText = "" */
            this.stopLoading()
          })
      },

      defineApi({
        demo,
        test
      }) {
        let url = ((test === true || test == "true") ? process.env.VUE_APP_TEST_URL : process.env.VUE_APP_URL)+'v'+process.env.VUE_WIDGET_VERSION+'/api'
        console.log('api: ', url)
        this.$api.url = url
        this.$api.useMocks = (demo === true || demo == 'true')
      },

      /**
       * Заворачиваем события с сайта к iframe в глобальную шину событий самого SPA
       */
      onMessage(event) {
        if (['update', 'search', 'update:search-props'].includes(event.data.eventName)) {
          let callbacks = {}
          if (event.data.callbacks) {
            for(let callbackName in event.data.callbacks) {
              callbacks[callbackName] = (args) => {
                this.postMessage('callback:invoke', { callbackId: event.data.callbacks[callbackName], callbackArgs: args })
              }
            }
          }
          this.$eventBus.$emit(`widget:${event.data.eventName}`, {data: event.data.options, callbacks})
        }
      },

      onWidgetUpdate({ data: newOptions }) {
        console.log('newOptions: ', newOptions)
        newOptions = Object.assign({}, this.$store.state.options, newOptions)
        this.$store.commit('SET_WIDGET_OPTIONS', newOptions)
      },

      onReload() {
        this.postMessage('dialog:close')

        if (this.$route.name != 'index') {
          this.$router.push({name: 'index'})
        }
        this.$nextTick(()=>{
          this.reloadWidget()
        })
      }

    },
    created() {
      this.startLoading()
      window.addEventListener('message', this.onMessage, false)
      this.$eventBus.$on('widget:update', this.onWidgetUpdate)
      this.$eventBus.$on('reload', this.onReload)
      this.fetchWidget()
    },
    beforeDestroy() {
      this.$eventBus.$off('widget:update', this.onWidgetUpdate)
      this.$eventBus.$off('reload', this.onReload)
      window.removeEventListener('message', this.onMessage, false)
    }
  }
</script>

<style>
  div.v-application--wrap {
    min-height: 100% !important;
  }

  .sgb-widget-base {
    background-color: white !important;
  }

  .sgb-widget-normal {
    min-width: 300px !important;


    min-height: 208px !important;
    width: 300px !important;
    /*     height: 264px !important; */
  }

  .sgb-widget-compact {
    min-width: 240px !important;


    min-height: 192px !important;
    width: 240px !important;
    /*     height: 196px !important; */
  }

  /* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active
{
    background-color: transparent !important;
 -webkit-box-shadow: 0 0 0 30px white inset !important;
}


</style>